import { FiExternalLink } from "react-icons/fi";

function ExternalLink({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{ display: "inline-flex", alignItems: "center", gap: "0.25rem" }}
    >
      {children}
      <FiExternalLink
        aria-hidden="true"
        style={{ fontSize: "0.9em", opacity: 0.75 }}
      />
    </a>
  );
}

export default ExternalLink;
